/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type VerifyUpdateOtpDTO = {
    channel: VerifyUpdateOtpDTO.channel;
    /**
     * Must be UPDATE_EMAIL or UPDATE_PHONE
     */
    purpose: VerifyUpdateOtpDTO.purpose;
    verificationCode: string;
};

export namespace VerifyUpdateOtpDTO {

    export enum channel {
        WEB = 'WEB',
        MOBILE = 'MOBILE',
        POS = 'POS',
    }

    /**
     * Must be UPDATE_EMAIL or UPDATE_PHONE
     */
    export enum purpose {
        SIGN_IN = 'SIGN_IN',
        NON_CUSTOMER_SIGN_UP = 'NON_CUSTOMER_SIGN_UP',
        CUSTOMER_SIGN_UP = 'CUSTOMER_SIGN_UP',
        TRANSACTION_PIN = 'TRANSACTION_PIN',
        CHANGE_PROFILE = 'CHANGE_PROFILE',
        CHANGE_PROFILE_PASSWORD = 'CHANGE_PROFILE_PASSWORD',
        TWO_FACTOR = 'TWO_FACTOR',
        MISMATCH_SIGN_UP = 'MISMATCH_SIGN_UP',
        CHANGE_OF_DEVICE = 'CHANGE_OF_DEVICE',
        SECURE_TRANSACTION = 'SECURE_TRANSACTION',
        UPDATE_EMAIL = 'UPDATE_EMAIL',
        UPDATE_PHONE = 'UPDATE_PHONE',
    }


}
